import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { LivrableCaractérisé } from './model/livrable-caracterisé.model';
import { LivrableCaractériséUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class LivrableCaractériséService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/livrables-caractérisés';

  trouverTous(idModule: string) {
    return this.#http.get<Response<LivrableCaractérisé>>(this.BASE_URL, { params: { idModule } });
  }

  modifier(id: string, data: LivrableCaractériséUpdateRequest) {
    return this.#http.put<void>(this.BASE_URL + '/' + id, data);
  }

  trouverParId(id: string) {
    return this.#http.get<LivrableCaractérisé>(this.BASE_URL + '/' + id);
  }
}
